import axios from "axios";

export const API = axios.create({
// baseURL: 'http://localhost:5052/',
  // baseURL: 'http://192.168.3.109:8080/ordermanagement/'
// baseURL: 'http://111.93.235.122:8080/ordermanagement/'
//  baseURL: 'http://111.93.235.122:8080/soms_ikea/'
 baseURL: 'https://soms.snowman.in:8443/ordermanagement/'
});
  